import { render, staticRenderFns } from "./HeatDissipationSystem.vue?vue&type=template&id=61ff0a4a&scoped=true"
import script from "./HeatDissipationSystem.vue?vue&type=script&lang=js"
export * from "./HeatDissipationSystem.vue?vue&type=script&lang=js"
import style0 from "./HeatDissipationSystem.vue?vue&type=style&index=0&id=61ff0a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ff0a4a",
  null
  
)

export default component.exports